import { Device, DeviceIntrinsics } from "@app/shared";
import { FC, useState } from "react";
import { toastSuccess } from "../../helpers/toastHelpers";
import { DeviceHomography } from "./DeviceHomography";
import { RequiresGoogleMaps } from "./maps/RequiresGoogleMaps";

type DeviceFusionProps = {
    device: Device;
    onChange?: () => any;
};

type FusionMethod = "Homography" | "Intrinsics" | "";

export const DeviceFusion: FC<DeviceFusionProps> = ({ device, onChange }) => {
    const getInitialMethod = (): FusionMethod => {
        if ((device.homographySourcePoints && device.homographySourcePoints.length > 0) &&
            (device.homographyDestinationPoints && device.homographyDestinationPoints.length > 0)) {
            return "Homography";
        }
        if (device.fusionOffsetPitch !== null && device.fusionOffsetPitch !== undefined && device.fusionOffsetPitch !== 0) {
            return "Intrinsics";
        }
        return "";
    };

    const [selectedMethod, setSelectedMethod] = useState<FusionMethod>(getInitialMethod());

    return (
        <div className="p-4">
            <div className="mb-4">
                <label htmlFor="fusionMethod" className="block text-sm font-medium mb-2">
                    Fusion Method
                </label>
                <select
                    id="fusionMethod"
                    value={selectedMethod}
                    onChange={(e) => setSelectedMethod(e.target.value as FusionMethod)}
                    className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="">Select Fusion Method</option>
                    <option value="Homography">Homography</option>
                    <option value="Intrinsics">Intrinsics</option>
                </select>
            </div>

            {selectedMethod === "Homography" && (
                <RequiresGoogleMaps>
                    <DeviceHomography device={device} onChange={onChange} />
                </RequiresGoogleMaps>
            )}

            {selectedMethod === "Intrinsics" && <DeviceIntrinsics device={device} onChange={onChange} onSuccess={toastSuccess} />}

            {selectedMethod === "" && (
                <div className="text-center text-gray-500 py-8">
                    Please select a fusion method to configure.
                </div>
            )}
        </div>
    );
};
